import * as React from 'react';
const DayPickerInput = require('react-day-picker/DayPickerInput');
import 'react-day-picker/lib/style.css';
import * as moment from 'moment';
const classNames = require('classnames');
import * as MobileDetect from 'mobile-detect';

import Label from './Label';
import { InputError } from '../../common/utils';
import { TextInput } from '.';

interface Props {
	labelText?: string;
	placeholder?: string;
	value?: string | Date;
	dateRangeStart?: Date;
	dateRangeEnd?: Date;
	onBlur?: (e: any) => void;
	onChange?: (e: any) => void;
	name: string;
	defaultValue?: string;
	required?: boolean;
	className?: string;
	id?: string;
	error?: InputError;
	disabled?: boolean;
}

// Component will receive date, locale and localeUtils props
function YearMonthForm({ date, fromMonth, toMonth, localeUtils, onChange }: any) {
	const months = localeUtils.getMonths();

	const years = [];
	for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
		years.push(i);
	}

	const handleChange = (e: any) => {
		const { year, month } = e.target.form;
		onChange(new Date(year.value, month.value));
	};

	return (
		<form className="DayPicker-Caption">
			<select name="month" className="form-control form-control-sm" onChange={handleChange} value={date.getMonth()}>
				{months.map((month: any, i: any) => (
					<option key={i} value={i}>
						{month}
					</option>
				))}
			</select>
			<select name="year" className="form-control form-control-sm" onChange={handleChange} value={date.getFullYear()}>
				{years.map((year, i) => (
					<option key={i} value={year}>
						{year}
					</option>
				))}
			</select>
		</form>
	);
}

class DatePicker extends React.Component<Props, any> {
	isCustomPicker: boolean;	

	constructor(props: any) {
		super(props);
		this.handleYearMonthChange = this.handleYearMonthChange.bind(this);
		this.state = {
			month: this.props.defaultValue
		};

		const md = new MobileDetect(window.navigator.userAgent);
		this.isCustomPicker = md.version('IE') || md.mobile() ? false : true;
	}

	formatDateForIE = (value?: string | Date) => {
		let formatted = value;

		if (typeof value === 'string' && value.length >= 8) {
			formatted = moment(value).isValid() ? moment(value).format('YYYY-MM-DD') : value;
		}
		else if (moment.isDate(value)) {
			formatted = moment(value).isValid() ? moment(value).format('YYYY-MM-DD') : value;
		}

		return formatted as any;
	}
	handleYearMonthChange = (month: any) => {
		this.setState({ month });
	}

	handleOnDayChange = (value?: Date | string, value2?: Object) => {
		if (this.props.onChange && value !== undefined) {
			const e = {
				target: {
					name: this.props.name,
					value: moment(value).format('YYYY-MM-DD')
				}
			};

			this.props.onChange(e);
		}
	}

	onKeyUp = (e: any) => {
		let value: string = e.target.value;
		if (value.match(/^\d{4}$/) !== null) {
			value = value + '-';
		} 
		else if (value.match(/^\d{4}-\d{2}$/) !== null) {
			value = value + '-';
		}

		if (this.props.onChange) {
			const e2 = {
				target: {
					name: this.props.name,
					value: value
				}
			};

			this.props.onChange(e2);
		}
	}
	onKeyDown = (e: any) => {		
		if (e.key === '-') {
			e.preventDefault();
		}
	}

	render() {
		const props = this.props;
		const currentDate = new Date();
		const currentYear = currentDate.getFullYear();
		const fromMonth = props.dateRangeStart || new Date(currentYear, currentDate.getMonth());
		const toMonth = props.dateRangeEnd || new Date(currentYear + 10, 11);

		return this.isCustomPicker ? (
			<div className={classNames('form-group', props.className, { 'custom-datepicker': this.isCustomPicker })}>
				{props.labelText && (
					<Label htmlFor={props.name} required={props.required}>
						{props.labelText}
					</Label>
				)}
				<div className="input-group">
					{props.disabled ? (
						<TextInput name={props.name} value={moment(props.value).format('YYYY-MM-DD')} disabled={props.disabled} />
					) : (
						<DayPickerInput
							className={classNames('form-control', { 'is-invalid': props.error && props.error.hasError })}
							id={props.id}
							name={props.name}
							type="text"
							format="YYYY-MM-DD"
							placeholder={props.placeholder || 'YYYY-MM-DD'}
							value={props.value}
							onDayChange={this.handleOnDayChange}
							defaultValue={props.defaultValue}
							dayPickerProps={{
								month: this.state.month,
								fromMonth: fromMonth,
								toMonth: toMonth,
								captionElement: (
									<YearMonthForm
										fromMonth={fromMonth}
										toMonth={toMonth}
										onChange={(month: any) => this.handleYearMonthChange(month)}
									/>
								)
							}}
							onBlur={this.props.onBlur}
							onKeyUp={this.onKeyUp}
							onKeyDown={this.onKeyDown}
						/>
					)}
					{props.error && <div className="invalid-feedback d-block">{props.error.message}</div>}
				</div>
			</div>
		) : (
			<TextInput
				labelText={props.labelText}
				className={props.className}
				id={props.id}
				name={props.name}
				type="date"
				placeholder={props.placeholder || 'YYYY-MM-DD'}
				value={this.formatDateForIE(props.value)}
				onChange={this.props.onChange}
				onBlur={this.props.onBlur}
				onKeyUp={this.onKeyUp}
				error={props.error}
				required={true}
			/>
		);
	}
}

export default DatePicker;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/DatePicker.tsx